/**
 * @fileoverview GET handler for the "/engagement/locations_apps" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementLocationsApps } from "./constants";
import type { EngagementLocationsAppsResult } from "./types";

export const getEngagementLocationsApps = reactQueryFetcherAdapter(
  engagementLocationsApps,
  (signal: AbortSignal): Promise<EngagementLocationsAppsResult> => {
    return fetch("/engagement/locations_apps", "GET", {}, { signal });
  }
);
